import store from '@/store/index'
import * as reqDataList from '@/config/reqDataList'
export default {
  beforeRouteEnter (to, from, next) {
    // 是否是返回(路径需要一定的规则)
    let isBack = false;
    //判断要访问的页面是否在查询列表中(并且是否从指定页面返回)
    let queryIndex = reqDataList.queryName.indexOf(to.name);
    let detailIndex = reqDataList.detailName.indexOf(from.name);
    if(queryIndex != -1 && detailIndex != -1){
      isBack = true;
    }
    // 从store里面拿到存储的值
    let reqData = store.state.publicInfo.reqDataList[to.name]
    console.log('reqData',reqData);
    if (!isBack) {
      //前进
      //使用默认值，并删除存储中的值
      reqData = {...reqDataList[to.name + 'QueryParam']};
      // 如果是前进，则清除store中存储的该组建的数据
      store.dispatch('uploadListParams', {routeName: to.name})
    }else if(!reqData){
      reqData = {...reqDataList[to.name + 'QueryParam']};
    }
    to.meta.reqData = reqData;
    next()
  },
  methods: {

  }
}
